import React from 'react';
import DeviceLink from 'app/components/links/DeviceLink';

const NmsInterfaceLink = ({ deviceId, deviceName, snmpId, children, ...rest }) => (
  <DeviceLink deviceId={deviceId} name={deviceName} snmp_id={snmpId} {...rest}>
    {children || snmpId}
  </DeviceLink>
);

export default NmsInterfaceLink;
